import { Text as PDFText, StyleSheet } from '../compiler'

const styles = StyleSheet.create({
  boldText: { fontWeight: 700 }
})

const parseText = (text) => {
  const regex = /\*\*(.*?)\*\*/g
  const parts = []
  let lastIndex = 0

  text.replace(regex, (match, p1, offset) => {
    if (offset > lastIndex) {
      parts.push(text.substring(lastIndex, offset)) // normal text
    }
    parts.push(
      <PDFText style={styles.boldText} key={offset}>
        {p1}
      </PDFText>
    ) // bold text
    lastIndex = offset + match.length
  })

  if (lastIndex < text.length) {
    parts.push(text.substring(lastIndex))
  }

  return parts
}

const handleNewLines = (text) => {
  const lines = text.split('\n\n')
  return lines.flatMap((line, index) => [
    index > 0 && <PDFText key={`br-${index}`}>{'\n'}</PDFText>, // add line break before
    parseText(line)
  ])
}

const Text = ({ children, ...props }) => {
  if (typeof children === 'string') {
    return <PDFText {...props}>{handleNewLines(children)}</PDFText>
  }

  return <PDFText {...props}>{children}</PDFText>
}

export default Text
